<template>
  <div class="shortlist-edit-footer">
    <button @click="exitShortlist" class="leave-button">
      Exit without saving
    </button>
    <button @click="internalNav">
      {{ currentStep === 0 ? "Continue" : "Go back" }}
    </button>
    <button @click="saveShortlist">Save</button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SharedShortlistsFooter",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: (state) => state.sharedShortlists.loading,
      currentStep: (state) => state.sharedShortlists.currentStep,
    }),
  },
  components: {},
  methods: {
    exitShortlist: function () {
      if (this.loading === true) {
        return;
      }

      this.$store.dispatch("sharedShortlists/exitEditing");
    },
    saveShortlist: function () {
      if (this.loading === true) {
        return;
      }
      this.$store.commit("setLoading", true);

      this.$store.dispatch("sharedShortlists/saveShortlist").then(() => {
        this.$store.commit("setLoading", false);
      });
    },
    internalNav: function () {
      if (this.currentStep === 0) {
        this.$store.commit("sharedShortlists/setCurrentStep", 1);
      } else if (this.currentStep === 1) {
        this.$store.commit("sharedShortlists/setCurrentStep", 0);
      }
    },
  },
};
</script>
